<div class="spinner-grow text-white" role="status">
  <span class="visually-hidden">{{ "common.loading" | translate }}</span>
</div>
